<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Guided Lens Selection</h4>
  <button type="button" class="close" (click)="activeModal.close()" aria-describedby="modal-title">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (lensType == LENS_TYPES.singleVision) {
    <app-go-single-vision [svLenses]="svLenses"
      [isAgainstRecommendation]="!isSingleVisionRecommended"
      (lensTypeChangeEvent)="lensTypeSwitch($event)"
      (addLensToCartEvent)="addLensToCart($event)">
    </app-go-single-vision>
  }
  @if (lensType == LENS_TYPES.bifocalProg) {
    <app-go-bf-prog-vision [bfProgLenses]="bfProgLenses"
      [isAgainstRecommendation]="isSingleVisionRecommended"
      (lensTypeChangeEvent)="lensTypeSwitch($event)"
      (addLensToCartEvent)="addLensToCart($event)">
    </app-go-bf-prog-vision>
  }
</div>

